import {useCallback} from 'react';
import {useTranslation} from 'react-i18next';

import {SelectOption} from '@veneer/core';

export const useValidateMinChoices: (
    minChoices: number
) => (values: string[] | SelectOption<string>[]) => string | null = minChoices => {
    const {t} = useTranslation(['validation']);
    return useCallback(
        values => {
            if (values.length < minChoices) {
                return t('validation:minChoices', {
                    count: minChoices,
                    defaultValue: 'Must choose at least {{count}} option',
                    defaultValue_other: 'Must choose at least {{count}} options',
                });
            }
            return null;
        },
        [t, minChoices]
    );
};
